export default "https://cdn-static.gokick.com/assets/f4ff00fe02dd4df624a9917ee1bd81ca642b4b73/images/tangerine-flavor.d69a41b483f65480106dc4280eb6f29c.png";